<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="dialog-precio-masivo">
        <v-alert type="info" outlined dense class="mt-4">
          {{ mensajeInformativo }}
        </v-alert>
        <v-alert
          v-if="sinEntidadesActivas"
          type="warning"
          outlined
          dense
          class="mt-2"
        >
          {{ mensajeSinEntidades }}
        </v-alert>
        <v-row class="mt-4">
          <v-col cols="12" sm="4" md="4">
            <v-text-field
              v-model="precioConsulta"
              prepend-icon="mdi-currency-usd"
              :rules="totalRules"
              label="Precio Consulta *"
              @blur="toFixed"
              @keypress="onlyNumberAndComma"
              maxlength="10"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="8" md="8" class="mt-2 flags">
            <v-checkbox
              v-model="esSena"
              label="Es Seña"
              color="primary"
              dense
            ></v-checkbox>
            <v-checkbox
              v-model="muestraEnWeb"
              label="Muestra precio en Web"
              color="primary"
              dense
            ></v-checkbox>
            <v-select
              class="mt-4"
              :items="requierePagoItems"
              v-model="obligaPago"
              item-text="text"
              item-value="value"
              label="Requiere pago para confirmar turno"
              dense
            ></v-select>
            <v-select
              class="mt-4"
              :items="cantDiasConfirmacionItems"
              v-model="cantDiasConfirmacion"
              item-text="text"
              item-value="value"
              label="Tiempo para confirmar turno"
              dense
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="success"
          :disabled="!puedeGuardar"
          :loading="guardando"
          @click.stop="guardar"
        >Guardar</v-btn>
        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "../../../axios-auth.js";

export default {
  data: () => ({
    precioConsulta: null,
    esSena: false,
    muestraEnWeb: false,
    obligaPago: 0,
    requierePagoItems: [
      { text: "No requiere", value: 0 },
      { text: "Sólo para turnos tomados en el portal", value: 1 },
      { text: "Sólo para los turnos dados internamente", value: 2 },
      { text: "Para todos los turnos", value: 3 },
    ],
    cantDiasConfirmacion: 0,
    cantDiasConfirmacionItems: [
      { value: 0, text: "En el transcurso del día" },
      { value: 1, text: "Hasta mañana inclusive" },
    ],
    totalRules: [
      (v) => !!v || v === 0 || v === "0" || "Dato obligatorio",
      (v) => v >= 0 || "El valor debe ser mayor o igual a 0",
    ],
    profesionalesActivos: [],
    obrasSocialesActivas: [],
    guardando: false,
    cargandoEntidades: false,
  }),
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    modo: {
      type: String,
      default: "porProfesional",
      validator: (value) =>
        ["porProfesional", "porObraSocial"].includes(value),
    },
    idEntidadCreada: {
      type: Number,
      default: null,
    },
    nombreEntidadCreada: {
      type: String,
      default: "",
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.cargarEntidadesActivas();
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.resetFields();
          this.$emit("close");
        }
      },
    },
    titulo() {
      return this.modo === "porProfesional"
        ? "Precio Consulta Masivo - Profesional"
        : "Precio Consulta Masivo - Obra Social";
    },
    mensajeInformativo() {
      return this.modo === "porProfesional"
        ? `Se aplicará a todas las obras sociales de la institución para el profesional ${this.nombreEntidadCreada}.`
        : `Se aplicará a todos los profesionales de la institución para la obra social ${this.nombreEntidadCreada}.`;
    },
    mensajeSinEntidades() {
      return this.modo === "porProfesional"
        ? "No hay obras sociales activas configuradas para la institución."
        : "No hay profesionales activos asociados a la institución.";
    },
    sinEntidadesActivas() {
      if (this.cargandoEntidades) return false;
      if (this.modo === "porProfesional") {
        return this.obrasSocialesActivas.length === 0;
      }
      return this.profesionalesActivos.length === 0;
    },
    precioValido() {
      const valor = this.precioConsulta;
      if (valor === null || valor === "" || valor === undefined) return false;
      const num = parseFloat(valor);
      if (isNaN(num)) return false;
      if (num < 0) return false;
      return true;
    },
    puedeGuardar() {
      return this.precioValido && !this.sinEntidadesActivas && !this.guardando;
    },
  },
  methods: {
    toFixed() {
      if (isNaN(parseFloat(this.precioConsulta)))
        this.precioConsulta = parseFloat(0.0).toFixed(2);
      else this.precioConsulta = parseFloat(this.precioConsulta).toFixed(2);
    },
    onlyNumberAndComma($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        $event.preventDefault();
      }
    },
    resetFields() {
      this.precioConsulta = null;
      this.esSena = false;
      this.muestraEnWeb = false;
      this.obligaPago = 0;
      this.cantDiasConfirmacion = 0;
      this.profesionalesActivos = [];
      this.obrasSocialesActivas = [];
    },
    cargarEntidadesActivas() {
      const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;
      this.cargandoEntidades = true;

      if (this.modo === "porObraSocial") {
        axios
          .get("/Turnos/BuscarProfesionalesAsociados?", {
            params: { idInstitucion, usuario: this.$store.state.usuario.usuario, },
          })
          .then((response) => {
            this.profesionalesActivos = response.data.profesionales || [];
          })
          .catch(() => {
            this.profesionalesActivos = [];
          })
          .finally(() => {
            this.cargandoEntidades = false;
          });
      } else {
        axios
          .get("/ObraSocial/GetObraSocialNomDeInst?", {
            params: { idInstitucion, estado: 1 },
          })
          .then((response) => {
            this.obrasSocialesActivas = response.data || [];
          })
          .catch(() => {
            this.obrasSocialesActivas = [];
          })
          .finally(() => {
            this.cargandoEntidades = false;
          });
      }
    },
    guardar() {
      if (this.modo === "porProfesional") {
        this.guardarPorProfesional();
      } else {
        this.guardarPorObraSocial();
      }
    },
    guardarPorProfesional() {
      // Implementado por tarea 2.3 en paralelo
      const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;
      const listaOs = this.obrasSocialesActivas.map((os) => os.idObraSocial);

      if (listaOs.length === 0) return;

      this.guardando = true;
      const params = {
        idProfesional: this.idEntidadCreada,
        listaOs,
        precioConsulta: this.precioConsulta,
        esSena: this.esSena,
        muestraEnWeb: this.muestraEnWeb,
        obligaPago: this.obligaPago,
        cantDiasConfirmacion: this.cantDiasConfirmacion,
      };

      axios
        .post("/ObraSocial/GuardarPrecio", params)
        .then((response) => {
          if (response.data === "error") {
            this.showAlert({
              icon: "success",
              title:
                "Precio registrado excepto para aquellas obras sociales que ya poseían un precio previamente configurado",
              timer: 4000,
            });
          } else {
            this.showAlert({
              icon: "success",
              title: "Precio registrado",
              timer: 2000,
            });
          }
          this.$emit("guardado");
          this.show = false;
        })
        .catch(() => {
          this.showAlert({
            icon: "error",
            title: "El precio no pudo ser registrado",
            timer: 2000,
          });
        })
        .finally(() => {
          this.guardando = false;
        });
    },
    async guardarPorObraSocial() {
      if (this.profesionalesActivos.length === 0) return;

      this.guardando = true;
      let huboOmisiones = false;
      let huboErrorRed = false;

      for (const prof of this.profesionalesActivos) {
        const params = {
          idProfesional: prof.idProfesional,
          listaOs: [this.idEntidadCreada],
          precioConsulta: this.precioConsulta,
          esSena: this.esSena,
          muestraEnWeb: this.muestraEnWeb,
          obligaPago: this.obligaPago,
          cantDiasConfirmacion: this.cantDiasConfirmacion,
        };

        try {
          const response = await axios.post("/ObraSocial/GuardarPrecio", params);
          if (response.data === "error") {
            huboOmisiones = true;
          }
        } catch {
          huboErrorRed = true;
          break;
        }
      }

      this.guardando = false;

      if (huboErrorRed) {
        this.showAlert({
          icon: "error",
          title: "El precio no pudo ser registrado",
          timer: 2000,
        });
        return;
      }

      if (huboOmisiones) {
        this.showAlert({
          icon: "success",
          title:
            "Precio registrado excepto para aquellos profesionales que ya poseían un precio previamente configurado",
          timer: 4000,
        });
      } else {
        this.showAlert({
          icon: "success",
          title: "Precio registrado",
          timer: 2000,
        });
      }

      this.$emit("guardado");
      this.show = false;
    },
    showAlert(alertInfo) {
      this.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
  },
};
</script>

<style scoped>
.dialog-precio-masivo {
  margin-top: 1rem;
}
.flags {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}
</style>
